import { render, staticRenderFns } from "./ProductTagModal.vue?vue&type=template&id=7090c0b3&scoped=true&"
import script from "./ProductTagModal.vue?vue&type=script&lang=js&"
export * from "./ProductTagModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductTagModal.vue?vue&type=style&index=0&id=7090c0b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7090c0b3",
  null
  
)

export default component.exports